import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
function Footer(){
    return (
        <Wrapper>
<Title>Contect Us</Title><br/>
<Section_div>
<Title_2>Address </Title_2><br/> 
Department of Urology, Seoul National University Hospital, Seoul National University College of Medicine 
<br/>101 Daehak-ro, Jongno-gu, Seoul 03080, Republic of Korea<br/>
<A href="/Map">View the map (Link)</A>
</Section_div>
<Section_div>
<Section_div2>
<Title_2>Tel </Title_2>
+82-2-2072-3899
</Section_div2>
<Section_div2>
<Title_2>Fax </Title_2>
+82-2-742-4665
</Section_div2>
<Section_div2>
<Title_2>Email </Title_2> 
drboss@snu.ac.kr
</Section_div2>
</Section_div>
      </Wrapper>
    )
}  
const Section_div2= styled.div`
    display : inline-block;
    width : 300px;
    vertical-align: top;
`
const Section_div = styled.div`
    margin : 30px 0 ; 
    font-family: "Table_content";        

`
const Wrapper = styled.div`
position : relative;
width : 1200px;
margin : 0 auto;
top : 90px;
background-color : #C9C9C9;
color : white;
text-align : center;
padding : 30px 15px;
box-sizing : border-box;
font-family: "En";        
line-height: 30px;
`

const A = styled.a`
    font-weight : bold; 
    font-size : 15px; 
    color : #404040;
    &:hover{
        color : white;
    }
`
const Title = styled.span`
font-family: "Table_title";        
font-weight : bold; 
font-size : 25px; 
color : #404040;
`
const Title_2 = styled.span`
font-family: "Table_title";        
font-weight : bold; 
font-size : 20px; 
color : #404040;
`
export default Footer;